import { FC, PropsWithChildren } from 'react';
import CopyButton from '../CopyButton/CopyButton';
import QRButton from '../QRButton/QRButton';

import styles from './CopyField.module.scss';

type CopyFieldProps = {
	label: string;
	copyContent: string;
	displayValue?: string;
};

const CopyField: FC<PropsWithChildren<CopyFieldProps>> = ({
	children,
	copyContent,
	displayValue,
	label,
}) => {
	return (
		<div className={styles.container}>
			<label className={styles.label}>{label}</label>
			<div className={styles.input}>
				<div className={styles.content}>{children}</div>
				<QRButton
					className={styles.icon}
					data={copyContent}
					label={label}
					displayValue={displayValue || copyContent}
				/>
				<CopyButton className={styles.icon} dataToCopy={copyContent} />
			</div>
		</div>
	);
};

export default CopyField;
